//import i18next from 'i18next';
import { nth, getPaymentStatus, tcStatus } from '../../utils';

// https://github.com/react-tools/react-table#columns
export const getColumns = () => {
  return [
    nth,
    {
      Header: 'Team name',
      accessor: 'name',
      maxWidth: 100
    },
    {
      Header: 'Robot Name',
      accessor: 'robotName',
      maxWidth: 100
    },
    {
      Header: 'Robot #',
      accessor: 'robotNumber',
      maxWidth: 70
    },
    {
      Header: 'Present',
      accessor: 'present',
      maxWidth: 70,
      id: 'present',
      accessor: row => !!(row.technicalControl || {} ).present,
      Cell: row => (row.original.technicalControl || {} ).present ? 'true' : 'false',
      filterable: true
    },
    {
      Header: 'Payment status',
      maxWidth: 180,
      id: 'paymentStatus',
      accessor: row => getPaymentStatus(row),
      Cell: ({ original }) => getPaymentStatus(original),
      filterable: true
    },
    tcStatus
  ];
};

export const DEFAULTSORTED = [
  { id: 'name', desc: false },
  { id: 'robotName', desc: false }
];

export const DEFAULTPAGESIZE = 20;



// WEBPACK FOOTER //
// ./src/private/common/components/TechnicalControls/table.conf.js